import { render, staticRenderFns } from "./StockRanking.vue?vue&type=template&id=2ee9e620&scoped=true&"
import script from "./StockRanking.vue?vue&type=script&lang=js&"
export * from "./StockRanking.vue?vue&type=script&lang=js&"
import style0 from "./StockRanking.vue?vue&type=style&index=0&id=2ee9e620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9e620",
  null
  
)

export default component.exports